import PropTypes from 'prop-types';
import classnames from 'clsx';
import css from './close-button.module.scss';

const CloseButton = ({
  id = '',
  iconKey = 'dialogClose',
  styles = {},
  testId = 'icon-cross',
  className = '',
  useFontIcon = false,
  hasDarkTheme,
  handleDialogClose,
}) => {
  let closeIconClassName;

  if (useFontIcon) {
    closeIconClassName = classnames(
      className,
      hasDarkTheme ? css.closeButtonDark : css.closeButton,
    );
  } else {
    closeIconClassName = classnames(
      className,
      hasDarkTheme ? css.closeButtonSvgDark : css.closeButtonSvg,
    );
  }

  return (
    <i
      id={id}
      key={iconKey}
      className={closeIconClassName}
      style={styles}
      data-testid={testId}
      onClick={handleDialogClose}
    />
  );
};

CloseButton.propTypes = {
  id: PropTypes.string,
  iconKey: PropTypes.string,
  styles: PropTypes.object,
  testId: PropTypes.string,
  className: PropTypes.string,
  useFontIcon: PropTypes.bool,
  hasDarkTheme: PropTypes.bool,
  handleDialogClose: PropTypes.func.isRequired,
};

export default CloseButton;
